import { Link } from 'react-router-dom';

export default function Hero() {
  const handleCTAClick = () => {
    const rankingSection = document.getElementById('ranking-section');
    if (rankingSection) {
      rankingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      {/* 背景画像 */}
      <div 
        className="absolute inset-0 bg-cover bg-no-repeat bg-center sm:bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/ff6740025fc963c349ebe8f6e3b62035.jpg')`
        }}
      ></div>
      
      {/* 半透明の黒オーバーレイ */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      
      {/* 2026年最新版バッジ - 右上 */}
      <div className="absolute top-20 sm:top-24 md:top-28 right-3 sm:right-8 md:right-12 z-20">
        <div className="inline-flex items-center gap-1.5 sm:gap-2 bg-gradient-to-r from-amber-400 to-yellow-400 text-gray-900 text-xs sm:text-sm font-bold px-3 sm:px-6 py-1.5 sm:py-3 rounded-full shadow-xl shadow-amber-500/30 animate-pulse">
          <i className="ri-medal-fill text-sm sm:text-lg"></i>
          <span className="whitespace-nowrap">2026年最新版</span>
        </div>
      </div>
      
      {/* メインコンテンツ */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 text-center w-full">
        {/* 大きな数字表示 */}
        <div className="mb-6 sm:mb-8">
          <p className="text-white/80 text-sm sm:text-lg md:text-xl font-medium mb-2 sm:mb-3 tracking-wide">
            入会キャンペーン実施中
          </p>
          <div className="flex items-baseline justify-center gap-1.5 sm:gap-3 flex-wrap">
            <span className="text-base sm:text-xl md:text-2xl font-bold text-white">最大</span>
            <span className="text-5xl sm:text-7xl md:text-8xl lg:text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-yellow-300 to-amber-400 drop-shadow-2xl tracking-tight leading-none">
              20,000
            </span>
            <span className="text-base sm:text-xl md:text-2xl font-bold text-white">円相当</span>
          </div>
          <p className="text-amber-300 text-lg sm:text-2xl md:text-3xl font-bold mt-2 sm:mt-3 tracking-wide">
            の特典がもらえる
          </p>
        </div>
        
        {/* サブテキスト */}
        <p className="text-white/90 text-sm sm:text-lg md:text-xl lg:text-2xl font-medium mb-8 sm:mb-12 leading-relaxed max-w-3xl mx-auto px-2">
          年会費無料・高還元率・即日発行カードを徹底比較
        </p>
        
        {/* CTAボタン - 2つ横並び */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 max-w-2xl mx-auto mb-8">
          <button
            onClick={handleCTAClick}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 sm:gap-3 bg-gradient-to-r from-teal-500 to-emerald-500 hover:from-teal-600 hover:to-emerald-600 text-white text-base sm:text-lg font-bold px-8 sm:px-10 py-4 sm:py-5 rounded-full transition-all duration-300 shadow-xl shadow-teal-500/30 hover:shadow-teal-500/50 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-bank-card-fill text-xl sm:text-2xl"></i>
            <span>今すぐお得なカードを見る</span>
          </button>
          
          <Link
            to="/diagnosis"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 sm:gap-3 bg-gradient-to-r from-red-500 to-rose-500 hover:from-red-600 hover:to-rose-600 text-white text-base sm:text-lg font-bold px-8 sm:px-10 py-4 sm:py-5 rounded-full transition-all duration-300 shadow-xl shadow-red-500/30 hover:shadow-red-500/50 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-questionnaire-fill text-xl sm:text-2xl"></i>
            <span>あなたに合うカード診断</span>
          </Link>
        </div>

        {/* 信頼性バッジ */}
        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 mt-8 sm:mt-12 px-2">
          <div className="flex items-center gap-1.5 sm:gap-2 text-white/70 text-xs sm:text-base">
            <i className="ri-shield-check-fill text-teal-400 text-base sm:text-lg"></i>
            <span className="whitespace-nowrap">年会費無料多数</span>
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2 text-white/70 text-xs sm:text-base">
            <i className="ri-percent-fill text-amber-400 text-base sm:text-lg"></i>
            <span className="whitespace-nowrap">高還元率</span>
          </div>
          <div className="flex items-center gap-1.5 sm:gap-2 text-white/70 text-xs sm:text-base">
            <i className="ri-time-fill text-rose-400 text-base sm:text-lg"></i>
            <span className="whitespace-nowrap">即日発行対応</span>
          </div>
        </div>
      </div>
      
      {/* 下部グラデーション */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}
